import { OnlineContainerEditConfiguration } from "./online-container-edit.routes";
import { OnlineContainerEditModel } from "./online-container-edit.model";
import { OnlineContainerMissingFieldController } from "./missing-field.controller";
import { OnlineSummaryController } from "./summary.controller";

import "./add-item/add-item.component";
import "./future-item.component";
import "./closing-item.component";
import "./past-item.component";
import "./last-bidder-toolbar.component";
import "./last-bidder-item.component";
import "./filter/filter.component";
import "../../shared/sort-menu/sort-menu.component";

angular
    .module("thor.online-container-edit", [
        "thor.online-containers.edit.add-item.component",
        "thor.online-containers.edit.future-item.component",
        "thor.online-containers.edit.closing-item.component",
        "thor.online-containers.edit.past-item.component",
        "thor.online-containers.edit.last-bidder-toolbar.component",
        "thor.online-containers.edit.last-bidder-item.component",
        "thor.online-containers.edit.filter.component",
        "thor.shared.sort-menu.component",
        "thor.shared.back-to-top-button.component"
    ])
    .config(OnlineContainerEditConfiguration)
    .service("onlineContainerEditModel", OnlineContainerEditModel)
    .controller("OnlineContainerMissingFieldController", OnlineContainerMissingFieldController)
    .controller("OnlineSummaryController", OnlineSummaryController);
